import { useFormik } from 'formik';
import Link from 'next/link';
import { useState } from 'react';
import * as Yup from 'yup';
import { useRouter } from 'next/router';

import InputField from '../components/form-fields/InputField';
import useUser from '@/components/useUser';
import PageLoadingMessage from '../components/PageLoadingMessage';
import { retrieveCSRFToken } from '../utils/ajax';

const formSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
});

const LoginMagicLink = () => {
  const { user, isLoading } = useUser();
  const router = useRouter();

  const [emailSent, setEmailSent] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: formSchema,
    onSubmit: async (params, { setSubmitting, setErrors }) => {
      const form = new FormData();
      form.append('email', params.email)

      setSubmitting(true);

      const res = await fetch('/api-auth/send-magic-link/', {
        method: 'POST',
        headers: {
          'X-CSRFToken': retrieveCSRFToken(),
        },
        body: form
      });

      if (res.ok) {
        setEmailSent(true);
      } else {
        console.error('res', res)
        setErrors({ server: 'something went wrong with the magic link' });
      }

      setSubmitting(false);
    }
  });

  if (isLoading) {
    return (
      <section className="section">
        <PageLoadingMessage />
      </section>
    );
  }

  if (user) {
    const path = new URLSearchParams(window.location.search).get('next') || '/';
    router.push(path);
  }

  return (
    <section className="section">
      <div className="container has-text-centered" style={{maxWidth: 480}}>
        <div className='px-6'>
          {formik.errors.server && (
            <div className="notification is-danger">
              <p>Unable to log in with provided email.</p>
            </div>
          )}

          {user && (
            <div className="notification">
              <p>You are already logged in! Redirecting you to the home page...</p>
            </div>
          )}

          {emailSent && (
            <div className="notification is-info">
              <p>Your Login link has been sent via email. Please check your inbox.</p>
            </div>
          )}
        </div>

        <div className="p-6">

          <div className="">
            <h2 className="subtitle">Send me a Link to Login</h2>
            <p className="pb-2">We'll send you an email with a link to log you into your account.</p>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <InputField fieldName="email" label="" formik={formik} placeholder="Your Email Address" />

            <button
              type="submit"
              className="button is-success is-fullwidth my-5"
              disabled={formik.isSubmitting || emailSent}
            >
              Send Login Link
            </button>
          </form>

          <div className="has-text-centered">
            <small><Link href={`/login`}>Remembered your password?</Link></small>
          </div>

          <div className="has-text-centered">
            <small><Link href={`/profile/password-reset`}>Forgot your password?</Link></small>
          </div>

          <div className="has-text-centered mt-3">
            <small>Don't have an account? <Link href={`/signup`}>Sign Up</Link></small>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LoginMagicLink;
